import { Link, NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth-context";

export default function Topbar() {
  const { me, logout } = useAuth();
  const location = useLocation();
  const signedIn = me?.signed_in === true;
  const onLanding = location.pathname === "/";

  // The landing page renders its own nav (brand + Start practicing) as part
  // of the hero, so the shared Topbar would duplicate the brand and crowd
  // the animation surface. Suppress the Topbar entirely on "/" — the rest
  // of the app keeps the topbar exactly as before.
  if (onLanding) return null;

  return (
    <header className="topbar">
      {/* Wordmark routes back to "/" without replaying the intro -- the
          Landing component's module-level latch (`hasPlayed`) is set
          true once the intro completes or is skipped, and Landing's
          mount-time check uses it to jump straight to the revealed
          hero state. Hard refresh resets the module → animation plays
          fresh. */}
      <Link
        to="/"
        className="brand"
        style={{ color: "inherit", textDecoration: "none" }}
      >
        MoreQuestions
      </Link>
      <nav className="nav">
        {signedIn && (
          <>
            <NavLink to="/practice" className={({ isActive }) => (isActive ? "active" : "")}>
              Practice
            </NavLink>
            <NavLink to="/dashboard" className={({ isActive }) => (isActive ? "active" : "")}>
              Dashboard
            </NavLink>
          </>
        )}
        <NavLink to="/about" className={({ isActive }) => (isActive ? "active" : "")}>
          About
        </NavLink>
        {signedIn && me.is_admin && (
          <NavLink to="/admin" className={({ isActive }) => (isActive ? "active" : "")}>
            Admin
          </NavLink>
        )}
        {signedIn ? (
          <>
            <span className="muted" style={{ fontFamily: "var(--font-mono)", fontSize: 13 }}>
              {me.blazerid}
            </span>
            <button className="btn btn--ghost" onClick={logout} style={{ padding: "6px 12px" }}>
              Sign out
            </button>
          </>
        ) : (
          <NavLink to="/access-code" className={({ isActive }) => (isActive ? "active" : "")}>
            Get started
          </NavLink>
        )}
      </nav>
    </header>
  );
}
